import { DoubleArrow, NotStarted, Public, PublicOff } from '@mui/icons-material';
import { Tooltip } from '@mui/material';
import { computed, makeObservable } from 'mobx';
import { inject, observer } from 'mobx-react';
import moment from 'moment';
import { Fragment } from 'react';
import Configuracao from '@/util/Configuracao';
import ReactComponent from '../ReactComponent';

class EstadoPauta extends ReactComponent {
    constructor(props) {
        super(props);

        makeObservable(this, {
            pautaJulgamento: computed,
            pautaPublicada: computed,
            pautaLiberada: computed
        });
    }

    get pautaJulgamento() {
        return this.pautaJulgamentoStore.pautaSelecionada;
    }

    get pautaPublicada() {
        if (this.isPautaPublicada()) {
            return (
                <Tooltip title="Pauta publicada">
                    <Public style={{ marginLeft: '5px' }} />
                </Tooltip>
            );
        } else {
            return (
                <Tooltip title="Pauta não publicada">
                    <PublicOff style={{ marginLeft: '5px' }} />
                </Tooltip>
            );
        }
    }

    get pautaLiberada() {
        if (this.isPautaLiberada()) {
            return (
                <Tooltip title="Pauta liberada">
                    <DoubleArrow style={{ marginLeft: '12px' }} />
                </Tooltip>
            );
        } else {
            return (
                <Tooltip title="Pauta não liberada">
                    <NotStarted style={{ marginLeft: '12px' }} />
                </Tooltip>
            );
        }
    }

    get existeSessaoPJe() {
        return (
            this.pautaJulgamentoStore.pautaSelecionada &&
            this.pautaJulgamentoStore.pautaSelecionada.sessoes.find(
                (sessao) => sessao.origem === Configuracao.ORIGEM_PJE
            )
        );
    }

    isPautaPublicada() {
        return (
            this.pautaJulgamento &&
            this.pautaJulgamento.prazos &&
            this.pautaJulgamento.prazos.dataPublicacaoPauta &&
            moment(this.pautaJulgamento.prazos.dataPublicacaoPauta, 'DD-MM-YYYY-HH-mm-ss').isBefore(moment())
        );
    }

    isPautaLiberada() {
        return this.pautaJulgamento && this.pautaJulgamento.pautaLiberada;
    }

    render() {
        return (
            <Fragment>
                {this.pautaPublicada}
                {!this.existeSessaoPJe && this.pautaLiberada}
            </Fragment>
        );
    }
}

export default inject('stores')(observer(EstadoPauta));
